const fa = {
  // Navigation
  home: "خانه",
  products: "محصولات",
  about: "درباره ما",
  contact: "تماس با ما",
  
  // Hero Section
  heroTitle: "لاویش",
  heroSlogan: "طعم عشق را بچشید",
  heroDescription: "مجموعه‌ای از بهترین میوه‌های خشک، آجیل، شیرینی، ترشی و مربا را کشف کنید. با عشق ساخته شده، با دقت تحویل داده می‌شود.",
  shopNow: "خرید کنید",
  learnMore: "بیشتر بدانید",
  
  // Products
  driedFruits: "میوه‌های خشک",
  driedFruitsDesc: "میوه‌های خشک با کیفیت عالی پر از شیرینی طبیعی",
  nuts: "آجیل",
  nutsDesc: "آجیل تازه و مغذی برای تنقلات سالم",
  sweets: "شیرینی",
  sweetsDesc: "شیرینی‌های سنتی ایرانی با دستور العمل‌های اصیل",
  pickles: "ترشی",
  picklesDesc: "سبزیجات ترشی شده و زیتون خوشمزه",
  jams: "مربا",
  jamsDesc: "مربای خانگی سرشار از طعم طبیعی میوه",
  
  // Product Items
  walnuts: "گردو",
  almonds: "بادام خام و نمکی",
  pistachios: "پسته خام، زعفرانی و نمکی",
  peanuts: "بادام زمینی",
  hazelnuts: "فندق",
  chickpeas: "نخود و کشمش",
  
  mangoLeaves: "برگ انبه",
  peaches: "هلو",
  plums: "آلو",
  apple: "سیب",
  banana: "موز",
  strawberries: "توت فرنگی",
  yellowPlums: "آلوی زرد",
  pineapples: "آناناس",
  figs: "انجیر",
  bukharaPlums: "آلوی بخارا",
  
  gaz: "گز",
  sohan: "سوهان",
  latifeh: "لطیفه",
  kalampeh: "کلمپه",
  fasaeiBread: "نان فسایی",
  datesArdeh: "خرما و ارده",
  iceCream: "بستنی و فالوده",
  pashmak: "پشمک حاج عبدالله",
  
  lyte: "انواع لیته",
  pearlGarlic: "سیر مروارید",
  olives: "زیتون",
  cultivatedOlives: "زیتون پرورشی",
  
  strawberryJam: "مربای توت فرنگی",
  carrotJam: "مربای هویج",
  blackcurrantJam: "مربای انگور سیاه",
  honey: "عسل",
  
  // About
  aboutTitle: "درباره لاویش",
  aboutDescription: "ما علاقه‌مند به ارائه بهترین انتخاب از محصولات غذایی سنتی و مدرن هستیم. تعهد ما به کیفیت و طعم‌های اصیل، هر لقمه را به تجربه‌ای فراموش‌نشدنی تبدیل می‌کند.",
  
  // Contact
  contactTitle: "با ما در تماس باشید",
  contactDescription: "دوست داریم از شما بشنویم. برای هر گونه سوال در مورد محصولاتمان با ما تماس بگیرید.",
  messageSentSuccess: "متشکریم! پیام شما با موفقیت ارسال شد.",
  messageSentError: "اوه! مشکلی پیش آمد. لطفاً دوباره امتحان کنید.",
  
  // Footer
  quickLinks: "لینک‌های سریع",
  followUs: "ما را دنبال کنید",
  allRightsReserved: "تمام حقوق محفوظ است",
  footerDescription: "آجیل، میوه‌های خشک، شیرینی‌های سنتی و محصولات دست‌ساز ایرانی با عشق تحویل داده می‌شود.",
  customerService: "خدمات مشتری",
  faq: "سوالات متداول",
  privacyPolicy: "حریم خصوصی",
  support: "پشتیبانی",
  newsletter: "خبرنامه",
  newsletterDescription: "برای دریافت پیشنهادات ویژه و به‌روزرسانی‌ها مشترک شوید",
  enterEmail: "ایمیل خود را وارد کنید",
  subscribe: "اشتراک",
  
  // Common
  viewAll: "مشاهده همه",
  addToCart: "افزودن به سبد",
  buyNow: "خرید فوری",
  shoppingCart: "سبد خرید",
  emptyCart: "سبد خرید شما خالی است",
  clearCart: "پاک کردن سبد",
  checkout: "تسویه حساب",
  total: "جمع کل",
  checkoutSuccess: "از خرید شما متشکریم! به زودی با شما تماس خواهیم گرفت.",
  
  // Cart Page
  cartItems: 'اقلام سبد خرید',
  clearAll: 'پاک کردن همه',
  continueShopping: 'ادامه خرید',
  orderSummary: 'خلاصه سفارش',
  freeShippingProgress: 'پیشرفت ارسال رایگان',
  subtotal: 'جمع جزء',
  shipping: 'هزینه ارسال',
  tax: 'مالیات',
  calculatedAtCheckout: 'در هنگام تسویه محاسبه می‌شود',
  proceedToCheckout: 'ادامه به تسویه حساب',
  havePromoCode: 'کد تخفیف دارید؟',
  enterCode: 'کد را وارد کنید',
  apply: 'اعمال',
  whyShopWithUs: 'چرا از ما خرید کنید؟',
  securePayment: 'پرداخت ۱۰۰٪ امن',
  returnPolicy: 'سیاست بازگشت ۳۰ روزه',
  customerSupport: 'پشتیبانی ۲۴/۷',
  qualityGuaranteed: 'کیفیت ممتاز تضمین شده',
  clearCartConfirm: 'پاک کردن سبد خرید؟',
  clearCartMessage: 'آیا مطمئن هستید که می‌خواهید همه اقلام را از سبد خرید حذف کنید؟ این عمل قابل بازگشت نیست.',
  cancel: 'لغو',
  itemTotal: 'جمع اقلام',
  addMoreForFreeShipping: '{amount} دیگر اضافه کنید تا ارسال رایگان شود!',
  yourCartIsEmpty: 'سبد خرید شما خالی است',
  emptyCartMessage: 'به نظر می‌رسد هنوز هیچ محصولی اضافه نکرده‌اید. شروع به خرید کنید و محصولات شگفت‌انگیز ما را کشف کنید!',
  startShopping: 'شروع خرید',
  yourCart: 'سبد خرید شما',
  
  // Products Page
  ourProducts: "محصولات ما",
  searchProducts: "جستجوی محصولات...",
  featuredCategories: "دسته‌بندی‌های ویژه",
  specialGifts: "هدایای ویژه",
  
  // Auth
  login: "ورود",
  logout: "خروج",
  profile: "پروفایل",
  welcomeBack: 'خوش آمدید',
  loginToAccount: 'وارد حساب خود شوید',
  createAccount: 'ایجاد حساب',
  joinLoveish: 'امروز به Loveish بپیوندید',
  email: 'ایمیل',
  password: 'رمز عبور',
  confirmPassword: 'تایید رمز عبور',
  firstName: 'نام',
  lastName: 'نام خانوادگی',
  enterPassword: 'رمز عبور خود را وارد کنید',
  enterFirstName: 'نام خود را وارد کنید',
  enterLastName: 'نام خانوادگی خود را وارد کنید',
  signIn: 'ورود',
  signingIn: 'در حال ورود...',
  creatingAccount: 'در حال ایجاد حساب...',
  forgotPassword: 'رمز عبور را فراموش کرده‌اید؟',
  verificationEmailSent: 'ایمیل تایید ارسال شد!',
  checkEmailToVerify: 'لطفاً ایمیل خود را بررسی کرده و روی لینک تایید کلیک کنید تا حساب خود را فعال کنید.',
  emailVerified: 'ایمیل با موفقیت تایید شد!',
  canNowLogin: 'اکنون می‌توانید وارد حساب خود شوید.',
  soldOut: 'تمام شد',
  comingSoon: 'به زودی',
  notifyWhenAvailable: 'زمان موجود شدن به من اطلاع بده',
  outOfStock: 'ناموجود'
};

export default fa;
